/**
 * Equipment 模块枚举定义（自动生成）
 * 
 * ⚠️ 此文件由 api:export-types 命令自动生成
 * ⚠️ 请勿手动编辑！如需修改，请修改后端Model常量后重新生成
 * 
 * @generated 2025-11-02T18:26:32.722149Z
 * @generator api:export-types v1.0.0
 */

/**
 * Equipment状态
 */
export enum EquipmentSTATUS {
  IDLE = 1,
  RUNNING = 2,
  MAINTENANCE = 3,
  SERVICING = 4,
  DISABLED = 5,
}

/**
 * EquipmentInspectionRecord类型
 */
export enum EquipmentInspectionRecordTYPE {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

/**
 * EquipmentInspectionRecordRESULT
 */
export enum EquipmentInspectionRecordRESULT {
  PASS = 'PASS',
  FAIL = 'FAIL',
}

/**
 * EquipmentMaintenanceLog类型
 */
export enum EquipmentMaintenanceLogTYPE {
  ROUTINE = 'ROUTINE',
  REPAIR = 'REPAIR',
  OVERHAUL = 'OVERHAUL',
}

/**
 * EquipmentMaintenanceLogRESULT
 */
export enum EquipmentMaintenanceLogRESULT {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
}

/**
 * EquipmentMaintenancePlan类型
 */
export enum EquipmentMaintenancePlanTYPE {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
}

/**
 * EquipmentMaintenancePlanCYCLE
 */
export enum EquipmentMaintenancePlanCYCLE {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

/**
 * EquipmentMaintenanceTask状态
 */
export enum EquipmentMaintenanceTaskSTATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  OVERDUE = 'OVERDUE',
  CANCELLED = 'CANCELLED',
}

/**
 * EquipmentRepair状态
 */
export enum EquipmentRepairSTATUS {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

/**
 * EquipmentRepairURGENCY
 */
export enum EquipmentRepairURGENCY {
  NORMAL = 1,
  URGENT = 2,
  CRITICAL = 3,
}

/**
 * EquipmentRepairFAULT
 */
export enum EquipmentRepairFAULT {
  TYPE_MECHANICAL = 'MECHANICAL',
  TYPE_ELECTRICAL = 'ELECTRICAL',
  TYPE_HYDRAULIC = 'HYDRAULIC',
  TYPE_OTHER = 'OTHER',
}

